import { render, staticRenderFns } from "./SupervisorLogin.vue?vue&type=template&id=b45eebb6&"
import script from "./SupervisorLogin.vue?vue&type=script&lang=js&"
export * from "./SupervisorLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports